"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsightIcon = void 0;
var Icon_1 = require("./Icon");
var INSIGHT_ICON_MAP = {
    "local:scatter": Icon_1.Icon.ScatterPlot,
    "local:donut": Icon_1.Icon.Donut,
    "local:headline": Icon_1.Icon.HeadlineChart,
    "local:treemap": Icon_1.Icon.TreeMap,
    "local:combo2": Icon_1.Icon.Combo,
    "local:heatmap": Icon_1.Icon.HeatMap,
    "local:bubble": Icon_1.Icon.Bubble,
    "local:bullet": Icon_1.Icon.Bullet,
    "local:bar": Icon_1.Icon.Bar,
    "local:table": Icon_1.Icon.Table,
    "local:area": Icon_1.Icon.StackedArea,
    "local:column": Icon_1.Icon.Column,
    "local:line": Icon_1.Icon.Line,
    "local:pushpin": Icon_1.Icon.Geo,
    "local:pie": Icon_1.Icon.Pie,
};
/**
 * @internal
 */
exports.InsightIcon = function (_a) {
    var visualizationUrl = _a.visualizationUrl, _b = _a.iconProps, iconProps = _b === void 0 ? {} : _b;
    if (!visualizationUrl || !INSIGHT_ICON_MAP[visualizationUrl]) {
        return null;
    }
    return INSIGHT_ICON_MAP[visualizationUrl](iconProps);
};
//# sourceMappingURL=InsightIcon.js.map